import React from 'react';
import uuidv4 from 'uuid/v4';

/**
 * Provide random guid for component. Can use as html-attribute "id"
 * @component
 * @category HOC
 * @param providedProps
 * @param {string} providedProps.guid - Random guid 
*/

const WithGuid = (Component) => {

  class WithGuid extends React.Component {

    constructor(props) {
      super(props);

      this.guid = uuidv4();
    }

    render() {
      return (
        <Component { ...this.props } 
                   guid = { this.guid }/>
      )
    }
  }

  return WithGuid;
};

export default WithGuid;